



























import Vue from "vue";
import { Component, Watch, Emit, Prop } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import './winner-category.less';
import {
  getNomineeCategoryData,
  getNomineeCategoryId,
  getNomineeItems,
  getWinnerCategoryData
} from "@/services/getNomineeData/getNomineeData";
import NomineeSimpleDropdown from "@/components/nominee-simple-dropdown/nominee-simple-dropdown.vue";
import nomineeProject from "@/components/nominee-project/nominee-project.vue";
import WinnerProject from "@/components/winner-project/winner-project.vue";
import {getWinnerItems} from "@/services/getWinnerData/getWinnerData";


@Component({
  components: {
    WinnerProject,
    NomineeSimpleDropdown,
    nomineeProject
  }
})
export default class winnerCategory extends Vue {
  @Prop() selectedCategory;
  private categoriesData :{ id: number, image: string, title: string, url: string }[]= [];
  private winnerItems :any[]= [];
  private nomineeItems :any[] = [];
  private localSelectedCategory :number = -1;
  private category :{}= {};
  private nomineeSelectedItems :any[] = [];
  private winnerSelectedItems :any[] = [];


  mounted() {
    this.categoriesData = getWinnerCategoryData();
    this.nomineeItems = getNomineeItems();
    this.winnerItems = getWinnerItems();
    this.setLocalSelectedCategory();
  }

  setLocalSelectedCategory(){
    if(this.selectedCategory == -1){
      this.localSelectedCategory = getNomineeCategoryId();
    }else{
      this.localSelectedCategory = this.selectedCategory;
    }
    this.category = this.categoriesData[this.localSelectedCategory-1];
    this.nomineeSelectedItems = this.nomineeItems[this.localSelectedCategory];
    this.winnerSelectedItems = this.winnerItems[this.localSelectedCategory];
  }
  @Watch("category", {immediate: true, deep: true})
  onSelectedCategory(category) {
    if (!$.isEmptyObject(category) && category.url != "/") {
      this.localSelectedCategory = category.id;
      this.nomineeSelectedItems = this.nomineeItems[category.id];
      this.winnerSelectedItems = this.winnerItems[category.id];
      history.pushState('', '', category.url);
    }
  }


  trans(key) {
    return translate(key);
  }
}
